module.exports = __webpack_public_path__ + "img/20_3.b8f122d9.png";